import { render, staticRenderFns } from "./Table8.vue?vue&type=template&id=a842b552&scoped=true&"
import script from "./Table8.vue?vue&type=script&lang=js&"
export * from "./Table8.vue?vue&type=script&lang=js&"
import style0 from "./Table8.vue?vue&type=style&index=0&id=a842b552&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a842b552",
  null
  
)

export default component.exports